<template>
  <article class="tariff-plan">
    <div class="tariff-plan__badge">
      <img :src="badgeSrc" alt="">
    </div>

    <div class="tariff-plan__body">
      <header class="tariff-plan__head">
        <div class="tariff-plan__head-main">
          <h2 class="tariff-plan__title">
            {{ title }}
          </h2>
          <div v-if="description" class="tariff-plan__description">
            {{ description }}
          </div>
        </div>

        <div v-if="tariff" class="tariff-plan__head-aside">
          <div :class="['tariff-plan__status', { 'tariff-plan__status_blocked': blocked }]">
            {{ blocked ? 'Заблокирован' : 'Активен' }}
          </div>
          <div v-if="connectedAt" class="tariff-plan__connected">
            Подключён с {{ connectedAtLabel }}
          </div>
        </div>
      </header>

      <div v-if="tariff" class="tariff-plan__price-block">
        <div class="tariff-plan__price">
          {{ tariff.price | amountWithCurrency }} <span class="tariff-plan__price-unit">/ мес</span>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
  import { formatIsoDateTime } from '@/util/date-time-helper'

  const DEFAULT_BADGE = '/img/billing/tariff-badge.png'

  export default {
    name: 'TariffPlanCard',
    props: {
      tariff: {
        type: Object,
        default: null,
      },
      dailyRate: {
        type: Number,
        default: 0,
      },
      monthlyRate: {
        type: Number,
        default: 0,
      },
      filialsCount: {
        type: Number,
        default: 0,
      },
      connectedAt: {
        type: String,
        default: null,
      },
      blocked: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      badgeSrc () {
        const image = this.tariff && this.tariff.image
        return image ? `${this.$store.getters['api/storage']}/images/${image}` : DEFAULT_BADGE
      },
      title () {
        return this.tariff ? `Тарифный план «${this.tariff.name}»` : 'Тариф не назначен'
      },
      description () {
        return this.tariff ? this.tariff.description : null
      },
      connectedAtLabel () {
        return formatIsoDateTime(this.connectedAt, 'd MMMM yyyy', '—', null, 'ru')
      },
    },
  }
</script>

<style lang="less" scoped>
.tariff-plan {
  container-type: inline-size;
  display: flex;
  align-items: stretch;
  background-color: #fff;
  border: 1px solid #c4cdd9;
  border-radius: 5px;
  padding: 24px;

  .media-xs({
    padding: 20px 16px;
  });

  &__badge {
    flex: 0 0 auto;
    width: 88px;
    height: 88px;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
    margin-left: 24px;
  }

  &__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
  }

  &__head-main {
    min-width: 0;
  }

  &__head-aside {
    flex: 0 0 auto;
    text-align: right;
  }

  &__title {
    font-size: 22px;
    font-weight: 700;
    color: #323030;
    line-height: 1.25;
    overflow-wrap: break-word;
  }

  &__description {
    margin-top: 6px;
    font-size: 12px;
    color: #757575;
  }

  &__status {
    font-size: 14px;
    font-weight: 500;
    color: @color-primary;

    &_blocked {
      color: @color-error;
    }
  }

  &__connected {
    margin-top: 6px;
    font-size: 11px;
    color: #757575;
  }

  // Цена прижата к низу: карточка тянется по соседней и не оставляет дыру под ценой
  &__price-block {
    margin-top: auto;
    padding-top: 28px;
  }

  &__price {
    font-size: 28px;
    font-weight: 700;
    color: #323030;
    line-height: 1.2;

    &-unit {
      font-size: 16px;
      font-weight: 400;
      color: #757575;
    }

    &-note {
      margin-top: 6px;
      font-size: 11px;
      color: #949191;
    }
  }
}

// Ширина карточки не идёт за вьюпортом: в ряду со способом оплаты она ужимается
// до ~460px уже на десктопе — пороги считаем по контейнеру, а не по медиазапросам.
// Заголовку не хватает места рядом со статусом — статус уходит под него строкой
@container (max-width: 560px) {
  .tariff-plan {
    &__badge {
      width: 64px;
      height: 64px;
    }

    &__body {
      margin-left: 16px;
    }

    &__head {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
    }

    &__head-aside {
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;
      gap: 4px 10px;
      text-align: left;
    }

    &__connected {
      margin-top: 0;
    }

    &__title {
      font-size: 18px;
    }

    &__price-block {
      padding-top: 20px;
    }

    &__price {
      font-size: 24px;
    }
  }
}

@container (max-width: 380px) {
  .tariff-plan {
    &__badge {
      width: 48px;
      height: 48px;
    }

    &__body {
      margin-left: 12px;
    }

    &__title {
      font-size: 16px;
    }

    &__price {
      font-size: 22px;
    }
  }
}
</style>
